<template>

  <b-modal v-model="isPrompt" :width="800" scroll="keep" :on-cancel="closeModal">
    <div class="modal-widget">
      <div class="modal-title">
        <div class="title" style="margin: 10px">Agregar Vehículo</div>
      </div>
      <div class="modal-body">
        <div class="columns">
          <div class="column">
            <b-field label="Número de tarjeta">
              <b-input placeholder="Número tarjeta"
                       type="text"
                       autocomplete="off"
                       v-model="item.identification" />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Matrícula, placa y/o descripción"
                     :key="updatePlate">
              <b-input placeholder="Matrícula y/o placa"
                       type="text"
                       autocomplete="off"
                       v-model="item.info.plate"
              />
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Fecha inicial">
              <b-datepicker
                name="initialDate"
                v-model="item.startDate"
                placeholder="Seleccione una fecha..."
                icon="calendar-today"
                :disabled="!isIndividual"
                :date-formatter="formatDate"
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Fecha final">
              <b-datepicker
                name="finalDate"
                v-model="item.finalDate"
                placeholder="Seleccione una fecha..."
                icon="calendar-today"
                :disabled="!isIndividual"
                :date-formatter="formatDate"
              />
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Chip Id">
              <b-input placeholder="Chip"
                       type="text"
                       autocomplete="off"
                       v-model="item.info.shipId" />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Estado*">
              <b-select
                placeholder="Estado"
                expanded
                v-model="item.status">
                <option
                  v-for="option in statusList"
                  :value="option.value"
                  :key="option.value"
                  :id="option.value">
                  {{ option.title }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Identificación propietario*">
              <div class="control-content">
                <UserAutocomplete
                  v-model="item.entityOwner"
                  name="identification"
                  :identification="item.entityOwner.identification"
                  placeholder="Buscar tercero..."
                  @onSearch="findEntity" />
              </div>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Nombre *">
              <b-input placeholder="Nombre" type="text"
                       autocomplete="off"
                       readonly="readonly"
                       v-model="item.entityOwner.name" />
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Tipo de vehículo*">
              <b-select
                placeholder="Tipo vehículo"
                expanded
                v-model="item.info.vehicle.classification">
                <option
                  v-for="option in vehicleTypeList"
                  :value="option"
                  :key="option.code"
                  :id="option.code">
                  {{ option.title }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Total *">
              <b-input placeholder="Total"
                       type="number"
                       v-model="total"
                       @blur="validateTotal"
                       icon="currency-usd" />
            </b-field>
          </div>

        </div>
        <div class="columns">
          <div class="column is-6">
            <b-field label="Fecha eliminación">
              <b-datepicker
                name="deleteDates"
                v-model="item.deletionDate"
                placeholder="Seleccione una fecha..."
                icon="calendar-today"
                :editable="true"
                :date-formatter="formatDate"
                :min-date="item.startDate" />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Antipassback">
              <vs-switch v-model="antipassback" />
            </b-field>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="columns">
          <div class="column text-right">
            <vs-button
              color="danger"
              type="filled"
              style="margin-right: 10px"
              @click="cancelEdit">
              Cancel
            </vs-button>
            <vs-button color="primary" type="filled" @click="save">Agregar</vs-button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import entityEndpoint from '@/endpoints/core/EntityEndpoint'
import UserAutocomplete from '@/components/Shared/Autocomplete/Users.vue'
import DateUtils, { FORMATS } from '@/global/DateUtils'
import toast from '@/global/ToastConfig'
import unityEndpoint from '@/endpoints/core/UnityEndpoint'
import kind from '@/global/lasting/EKind'
import { isGreaterThan } from '@/global/utils'

export default {
  name: 'ParkingItem',
  components: { UserAutocomplete },
  props: {
    isShow: Boolean,
    record: Object,
    service: Object
  },
  data() {
    return {
      originalItem: {},
      updatePlate: 0,
      isPrompt: false,
      title: 'Agregar vehículo',
      clientWidth: 0,
      isIndividual: false,
      vehicleTypeList: [],
      antipassback: false,
      item: {
        position: null,
        identification: '',
        entityOwner: { code: null, identification: '' },
        total: null,
        startDate: this.startDate,
        finalDate: this.endDate,
        deletionDate: null,
        status: 'PENDING',
        antipasback: 'OFF',
        info: {
          shipId: '',
          plate: '',
          vehicle: {
            classification: {
              code: null,
              initials: null
            }
          }
        }
      },
      total: 0,
      forceRender: 0,
      statusList: [
        { value: 'ACTIVE', title: 'Activo' },
        { value: 'DELETED', title: 'Eliminado' },
        { value: 'PENDING', title: 'Pendiente' },
        { value: 'BLOCKED', title: 'Bloqueado' }
      ]
    }
  },
  mounted() {
    this.item = this.record ? this.record : this.item
    this.originalItem = JSON.parse(JSON.stringify(this.item))
    this.isIndividual = this.service.isPartial && this.service.isPartial === 'YES'
    if (!this.record) {
      this.item.startDate = new Date()
      this.item.finalDate = this.service.finalDate
    }
    this.antipassback = this.item.antipasback === 'ON'
    this.isPrompt = this.isShow
    this.total = this.item ? this.item.total : 0
    unityEndpoint.getUnityListByKind(kind.VEHICLE_TYPE)
      .then(info => {
        this.vehicleTypeList = info
        const recordInfo = this.record && this.record.info
        if (recordInfo
          && recordInfo.vehicle
          && recordInfo.vehicle.classification) {
          this.record.info.vehicle.classification = info.find(item =>
            item.code === recordInfo.vehicle.classification.code
          )
        }
      })
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue === '') {
        return
      }
      if (!isGreaterThan(newValue, 0)) {
        this.total = oldValue || 0
      }
      this.item.total = this.total
    },
    'item.info.plate'(newValue, oldValue) {
      newValue = newValue.toUpperCase()
      if (oldValue === newValue) return
      this.item.info.plate = newValue
      const allow = newValue.replace(/[^A-Z0-9]/g, '')
      if (allow !== newValue)
        setTimeout(() => this.item.info.plate = allow, 1)
    }
  },
  methods: {
    validateTotal() {
      if (this.total === '' || this.total === null
        || this.total === undefined || this.total < 0 || this.item.total < 0) {
        toast.error('El total debe ser mayor o igual a cero')
        this.total = 0
      }
      this.item.total = this.total
    },
    save() {
      try {
        this.validateItem()
        const event = this.record && this.record.info.plate && this.record.info.plate !== ''
          ? 'editItem'
          : 'saveItem'
        this.item.antipasback = this.antipassback ? 'ON' : 'OFF'
        this.$emit(event, this.item)
        this.closeModal()
      } catch (ex) {
        toast.error(ex.message)
      }
    },
    cancelEdit() {
      this.closeModal()
      setTimeout(() => Object.assign(this.item, this.originalItem), 2)
    },
    closeModal() {
      this.isPrompt = false
      setTimeout(() => this.$emit('closePrompt'), 1)
    },
    formatDate(a) {
      return DateUtils.toDateShortString({ date: a })
    },
    findEntity({ action, searchQuery, callback }) {
      if (action !== 'ASYNC_SEARCH') {
        return
      }
      entityEndpoint.findByNameOrIdentificationAutocomplete(searchQuery)
        .then((info) => {
          this.entityList = info.map(item => {
            return { label: item.title, id: item.code }
          })
          callback(null, this.entityList)
        })
    },
    validateItem() {
      if (!this.item.info.plate || this.item.info.plate === '') {
        throw new Error('Debe ingresar una placa/matricula/descripción')
      }
      if (!this.item.startDate) {
        throw new Error('Debe seleccionar una fecha inicial')
      }
      if (!this.item.finalDate) {
        throw new Error('Debe seleccionar una fecha final')
      }
      if (!this.item.status) {
        throw new Error('Debe seleccionar un estado')
      }
      if (!this.item.entityOwner.code) {
        throw new Error('Debe seleccionar el propietario')
      }
      if (this.item.total === undefined
        || this.item.total === null
        || this.item.total === ''
        || this.item.total < 0) {
        throw new Error('Debe ingresar el valor de la mensualidad')
      }
      if (this.item.status === 'DELETED' && !this.item.deletionDate) {
        throw new Error('Debe seleccionar la fecha de eliminación')
      }
      if (this.item.status !== 'PENDING' && !this.item.identification) {
        throw new Error('Si se requiere dejar el registro Activo se debe de ingresar el número de tarjeta' +
          ' de lo contrario dejar el registro en estado Pendiente')
      }
      if (!this.item.info.vehicle
        || !this.item.info.vehicle.classification
        || !this.item.info.vehicle.classification.code) {
        throw new Error('Debe seleccionar el tipo de vehículo')
      }
    }
  }
}
</script>

<style>
.con-vs-popup .vs-popup {
  width: 80% !important;
}
</style>